export const BODY_STYLE = `font-family: 'Proxima Vara', sans-serif; font-size: 16px; line-height: 1.5rem; font-weight: 400; color: unset;`;

export const htmlNodes = {
  h1: (content: string) =>
    `<h1 style="font-size: 1.25rem; font-weight: bold; line-height: 1.75rem;">${content}</h1>`,
  h2: (content: string) =>
    `<h2 style="font-size: 1.125rem; font-weight: bold; line-height: 1.5rem;">${content}</h2>`,
  h3: (content: string) =>
    `<h3 style="font-size: 1rem; font-weight: bold; line-height: 1.5rem;">${content}</h3>`,
  h4: (content: string) =>
    `<h4 style="font-size: 1rem; font-weight: bold; line-height: 1.5rem;">${content}</h4>`,
  h5: (content: string) =>
    `<h5 style="font-size: 0.875rem; font-weight: bold; line-height: 1.25rem;">${content}</h5>`,
  span: (content: string) =>
    `<span style="font-size: 0.875rem; font-weight: bold; line-height: 1.25rem;">${content}</span>`,
  unorderedList: (content: string) => `<ul>${content}</ul>`,
  unorderedListItem: (content: string) => `<li>${content}</li>`,
  orderedList: (content: string) => `<ol>${content}</ol>`,
  orderedListItem: (content: string) => `<li>${content}</li>`,
  code: (content: string) =>
    `<code style="padding: 4px; background-color: gainsboro; color: gray;">${content}</code>`,
  strong: (content: string) =>
    `<strong style="font-weight: bold;">${content}</strong>`,
  em: (content: string) => `<em style="font-style: italic;">${content}</em>`,
  a: (content: string, href: string) =>
    `<a href="${href}" style="font-size: 0.75rem; font-weight: bold; line-height: 1rem; color: gray; text-decoration: none;" target="_blank" rel="noopener noreferrer">${content}</a>`,
  codeBlock: (content: string) =>
    `<pre style="padding: 16px; background-color: #f5f5f5; color: #333; border-radius: 4px; overflow-x: auto; white-space: pre; margin: 16px 0;"><code>${content}</code></pre>`,
  img: (src: string) =>
    `<img src="${src}" style="max-width: 100%; height: auto;" />`,
  table: (content: string) =>
    `<table style="border-collapse: collapse; width: 100%; border: 1px solid #ddd;">${content}</table>`,
  th: (content: string) =>
    `<th style="padding: 8px 12px; border: 1px solid #ddd; font-size: 0.75rem; text-align: right;">${content}</th>`,
  td: (content: string | number) =>
    `<td style="padding: 8px 12px; border: 1px solid #ddd; font-size: 0.875rem; text-align: right;">${content}</td>`,
  tr: (content: string) => `<tr>${content}</tr>`,
};
